#import '../../../../../activity-modal/graphql/fragments/potential-activity-entity-fragment.graphql'

fragment ActivityForWidgetFragment on Activity {
    id
    name
    activityType {
        id
        icon
    }
    startTime
    endTime
    isAllDay
    isOverdue
    externalMeeting {
        id
    }
    participants {
        ...PotentialActivityEntityFragment
    }
    isPrivate
}
